<template>
  <div id="TablooElanatPage">
    <panel
      Title="تابلو اعلانات"
      Des="از طریق این فرم می‌توانید اعلانات شعبه را ثبت و مدیریت کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-tab
          :Tabs="ElanatTabs"
          :Active="activeTab"
          @change="onTabChange"
        ></net-pa-tab>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-elanat-list' }"
            id="nav-elanat-list"
            role="tabpanel"
            aria-labelledby="nav-elanat-list-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <div class="tabloo-elanat-cards" dir="rtl">
                  <p v-if="!Rows.length" class="tabloo-elanat-cards__empty">
                    اطلاعاتی یافت نشد
                  </p>
                  <template v-else>
                    <div class="tabloo-elanat-cards__toolbar">
                      <input
                        v-model="cardSearch"
                        type="search"
                        class="form-control tabloo-elanat-cards__search"
                        placeholder=" جستجو"
                        aria-label="جستجو در اعلانات"
                      />
                    </div>
                    <p
                      v-if="filteredCardRows.length === 0"
                      class="tabloo-elanat-cards__empty"
                    >
                      اطلاعاتی یافت نشد
                    </p>
                    <div v-else class="tabloo-elanat-cards__list">
                      <article
                        v-for="(row, index) in pagedCardRows"
                        :key="(row.id || 'elanat') + '-' + index"
                        class="tabloo-elanat-card"
                      >
                        <div class="tabloo-elanat-card__header">
                          <strong class="tabloo-elanat-card__name">{{
                            row.subjectTabloElanat || "اعلان"
                          }}</strong>
                          <span
                            class="tabloo-elanat-card__badge"
                            :class="
                              row.isActive
                                ? 'tabloo-elanat-card__badge--on'
                                : 'tabloo-elanat-card__badge--off'
                            "
                          >
                            {{ row.isActive ? "فعال" : "غیر فعال" }}
                          </span>
                        </div>
                        <p
                          v-if="row.txtMatnTabloElanat"
                          class="tabloo-elanat-card__text"
                        >
                          {{ row.txtMatnTabloElanat }}
                        </p>
                        <div class="tabloo-elanat-card__fields">
                          <div class="tabloo-elanat-card__field">
                            <span>تاریخ شروع</span>
                            <strong>{{ cardValue(row.azTarixSaat) }}</strong>
                          </div>
                          <div class="tabloo-elanat-card__field">
                            <span>تاریخ پایان</span>
                            <strong>{{ cardValue(row.taTarixSaat) }}</strong>
                          </div>
                        </div>
                        <div class="tabloo-elanat-card__actions">
                          <button
                            type="button"
                            class="tabloo-elanat-chip tabloo-elanat-chip--detail"
                            title="جزئـــیات"
                            @click="GetDetail(row)"
                            data-toggle="modal"
                            data-target="#Modal-Orange"
                          >
                            <i class="fa fa-list" aria-hidden="true"></i>
                            جزئیات
                          </button>
                          <button
                            type="button"
                            class="tabloo-elanat-chip tabloo-elanat-chip--edit"
                            title="ویرایش"
                            @click="OnEdit(row, $session.get('IsRahbar'))"
                          >
                            <i class="fas fa-pen" aria-hidden="true"></i>
                            ویرایش
                          </button>
                          <button
                            type="button"
                            class="tabloo-elanat-chip tabloo-elanat-chip--delete"
                            title="حذف"
                            @click="OnDelete(row)"
                          >
                            <i class="fas fa-trash" aria-hidden="true"></i>
                            حذف
                          </button>
                          <button
                            v-if="row.isActive == true"
                            type="button"
                            class="tabloo-elanat-chip tabloo-elanat-chip--off"
                            @click="Active(row, false)"
                          >
                            <i class="fas fa-eye-slash" aria-hidden="true"></i>
                            غیر فعال کردن
                          </button>
                          <button
                            v-if="row.isActive == false"
                            type="button"
                            class="tabloo-elanat-chip tabloo-elanat-chip--on"
                            @click="Active(row, true)"
                          >
                            <i class="fas fa-eye" aria-hidden="true"></i>
                            فعال کردن
                          </button>
                        </div>
                      </article>
                    </div>
                    <div
                      v-if="filteredCardRows.length > cardPerPage"
                      class="tabloo-elanat-cards__pager"
                    >
                      <button
                        type="button"
                        class="tabloo-elanat-cards__pager-btn"
                        :disabled="cardPage <= 1"
                        @click="cardPage = cardPage - 1"
                      >
                        قبلی
                      </button>
                      <span class="tabloo-elanat-cards__pager-info">
                        صفحه {{ cardPage }} از {{ cardPageCount }}
                      </span>
                      <button
                        type="button"
                        class="tabloo-elanat-cards__pager-btn"
                        :disabled="cardPage >= cardPageCount"
                        @click="cardPage = cardPage + 1"
                      >
                        بعدی
                      </button>
                    </div>
                  </template>
                </div>

                <div class="tabloo-elanat-table-view">
                  <vue-bootstrap4-table
                    v-if="$store.state.renderComponentGrid"
                    :rows="Rows"
                    :columns="Columns"
                    :config="config"
                    :classes="classes"
                  >
                    <template slot="sort-asc-icon">
                      <i class="fa fa-sort-up"></i>
                    </template>
                    <template slot="sort-desc-icon">
                      <i class="fa fa-sort-down"></i>
                    </template>
                    <template slot="no-sort-icon">
                      <i class="fa fa-sort"></i>
                    </template>
                    <template slot="empty-results">
                      <p class="text-right">اطلاعاتی یافت نشد</p>
                    </template>
                    <template slot="row" slot-scope="props">
                      <p class="text-center">{{ props.row.vbt_id }}</p>
                    </template>
                    <template slot="Action" slot-scope="props">
                      <div class="tabloo-elanat-table-actions">
                        <button
                          type="button"
                          title="جزئـــیات"
                          class="tabloo-elanat-chip tabloo-elanat-chip--detail"
                          @click="GetDetail(props.row)"
                          data-toggle="modal"
                          data-target="#Modal-Orange"
                        >
                          <i class="fa fa-list" aria-hidden="true"></i>
                          جزئیات
                        </button>
                        <button
                          type="button"
                          title="ویرایش"
                          class="tabloo-elanat-chip tabloo-elanat-chip--edit"
                          @click="OnEdit(props.row, $session.get('IsRahbar'))"
                        >
                          <i class="fas fa-pen" aria-hidden="true"></i>
                          ویرایش
                        </button>
                        <button
                          type="button"
                          title="حذف"
                          class="tabloo-elanat-chip tabloo-elanat-chip--delete"
                          @click="OnDelete(props.row)"
                        >
                          <i class="fas fa-trash" aria-hidden="true"></i>
                          حذف
                        </button>
                        <button
                          v-if="props.row.isActive == true"
                          type="button"
                          class="tabloo-elanat-chip tabloo-elanat-chip--off"
                          @click="Active(props.row, false)"
                        >
                          <i class="fas fa-eye-slash" aria-hidden="true"></i>
                          غیر فعال کردن
                        </button>
                        <button
                          v-if="props.row.isActive == false"
                          type="button"
                          class="tabloo-elanat-chip tabloo-elanat-chip--on"
                          @click="Active(props.row, true)"
                        >
                          <i class="fas fa-eye" aria-hidden="true"></i>
                          فعال کردن
                        </button>
                      </div>
                    </template>
                    <template slot="isActive" slot-scope="props">
                      <span
                        class="tabloo-elanat-card__badge"
                        :class="
                          props.row.isActive
                            ? 'tabloo-elanat-card__badge--on'
                            : 'tabloo-elanat-card__badge--off'
                        "
                      >
                        {{ props.row.isActive == true ? "فعال" : "غیر فعال" }}
                      </span>
                    </template>
                  </vue-bootstrap4-table>
                </div>
              </template>
            </net-pa-card>
          </div>

          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-elanat-form' }"
            id="nav-elanat-form"
            role="tabpanel"
            aria-labelledby="nav-elanat-form-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <div class="tabloo-elanat-form" id="TablooElanat" dir="rtl">
                  <div
                    v-if="
                      $session.get('ModirShobe') && !$session.get('IsRahbar')
                    "
                    class="tabloo-elanat-banner"
                  >
                    <strong>مدیریت شعبه: {{ TafsilyList.nameTafsiliType }}</strong>
                    <span
                      >اعلانات ثبت‌شده توسط شما فقط برای شعبه شما نمایش داده
                      می‌شود.</span
                    >
                  </div>

                  <label
                    v-if="$session.get('IsRahbar')"
                    class="tabloo-elanat-field tabloo-elanat-field--wide"
                  >
                    <span class="tabloo-elanat-label">انتخاب شعبه</span>
                    <treeselect
                      name="demo"
                      :multiple="multiple"
                      :clearable="clearable"
                      :searchable="searchable"
                      :disabled="disabled"
                      :open-on-click="openOnClick"
                      :open-on-focus="openOnFocus"
                      :clear-on-select="clearOnSelect"
                      :close-on-select="closeOnSelect"
                      :always-open="alwaysOpen"
                      :append-to-body="appendToBody"
                      :options="options3"
                      v-model="value3"
                      :normalizer="normalizer3"
                      @select="ItemSelected3"
                      @deselect="ItemDeselect3"
                    ></treeselect>
                  </label>

                  <div class="tabloo-elanat-fields">
                    <label class="tabloo-elanat-field tabloo-elanat-field--lg">
                      <span class="tabloo-elanat-label">عنوان اعلان</span>
                      <input
                        type="text"
                        class="form-control required"
                        v-model="DataAxios.SubjectTabloElanat"
                      />
                    </label>
                    <label class="tabloo-elanat-field">
                      <span class="tabloo-elanat-label">تاریخ شروع نمایش</span>
                      <date-picker
                        :editable="true"
                        :auto-submit="true"
                        color="#287db4"
                        v-model="DataAxios.AzTarixSaat"
                        input-class="required form-control"
                      ></date-picker>
                    </label>
                    <label class="tabloo-elanat-field">
                      <span class="tabloo-elanat-label">تاریخ پایان نمایش</span>
                      <date-picker
                        :editable="true"
                        :auto-submit="true"
                        color="#287db4"
                        v-model="DataAxios.TaTarixSaat"
                        input-class="required form-control"
                      ></date-picker>
                    </label>
                    <label class="tabloo-elanat-field tabloo-elanat-field--sm">
                      <span class="tabloo-elanat-label">ترتیب</span>
                      <input
                        type="text"
                        class="form-control"
                        maxlength="2"
                        dir="ltr"
                        v-model="DataAxios.Tartib"
                      />
                    </label>
                    <label class="tabloo-elanat-field tabloo-elanat-field--wide">
                      <span class="tabloo-elanat-label">متن اعلان</span>
                      <textarea
                        rows="5"
                        class="form-control required"
                        v-model="DataAxios.TxtMatnTabloElanat"
                      ></textarea>
                    </label>
                  </div>

                  <div class="tabloo-elanat-form__actions">
                    <button
                      v-if="!EditMode"
                      type="button"
                      class="tabloo-elanat-btn tabloo-elanat-btn--primary"
                      @click="SetBoard"
                    >
                      <i class="fas fa-plus" aria-hidden="true"></i>
                      ثبت تابلو اعلانات
                    </button>
                    <button
                      v-if="EditMode"
                      type="button"
                      class="tabloo-elanat-btn tabloo-elanat-btn--primary"
                      @click="Edit"
                    >
                      <i class="fas fa-pen" aria-hidden="true"></i>
                      ویرایش تابلو اعلانات
                    </button>
                    <button
                      v-if="EditMode"
                      type="button"
                      class="tabloo-elanat-btn tabloo-elanat-btn--ghost"
                      @click="CancelEdit"
                    >
                      <i class="fas fa-times" aria-hidden="true"></i>
                      انصراف
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
        </div>
      </div>
    </div>

    <modal-custom v-if="$store.state.renderComponent">
      <template v-slot:ContentModalOrange>
        <div class="tabloo-elanat-detail" dir="rtl">
          <h6 class="tabloo-elanat-detail__title">جزئیات شعبه‌ها</h6>
          <div class="tabloo-elanat-cards tabloo-elanat-detail-cards">
            <p
              v-if="!RowsDetail.length"
              class="tabloo-elanat-cards__empty"
            >
              اطلاعاتی یافت نشد
            </p>
            <template v-else>
              <div class="tabloo-elanat-cards__toolbar">
                <input
                  v-model="detailCardSearch"
                  type="search"
                  class="form-control tabloo-elanat-cards__search"
                  placeholder=" جستجو"
                  aria-label="جستجو در شعبه‌ها"
                />
              </div>
              <p
                v-if="filteredDetailCardRows.length === 0"
                class="tabloo-elanat-cards__empty"
              >
                اطلاعاتی یافت نشد
              </p>
              <div v-else class="tabloo-elanat-cards__list">
                <article
                  v-for="(row, index) in pagedDetailCardRows"
                  :key="(row.id || 'detail') + '-' + index"
                  class="tabloo-elanat-card"
                >
                  <div class="tabloo-elanat-card__header">
                    <strong class="tabloo-elanat-card__name">{{
                      row.nameTafsiliType || "شعبه"
                    }}</strong>
                    <span
                      class="tabloo-elanat-card__badge"
                      :class="
                        row.isActive
                          ? 'tabloo-elanat-card__badge--on'
                          : 'tabloo-elanat-card__badge--off'
                      "
                    >
                      {{ row.isActive ? "فعال" : "غیر فعال" }}
                    </span>
                  </div>
                </article>
              </div>
              <div
                v-if="filteredDetailCardRows.length > detailCardPerPage"
                class="tabloo-elanat-cards__pager"
              >
                <button
                  type="button"
                  class="tabloo-elanat-cards__pager-btn"
                  :disabled="detailCardPage <= 1"
                  @click="detailCardPage = detailCardPage - 1"
                >
                  قبلی
                </button>
                <span class="tabloo-elanat-cards__pager-info">
                  صفحه {{ detailCardPage }} از {{ detailCardPageCount }}
                </span>
                <button
                  type="button"
                  class="tabloo-elanat-cards__pager-btn"
                  :disabled="detailCardPage >= detailCardPageCount"
                  @click="detailCardPage = detailCardPage + 1"
                >
                  بعدی
                </button>
              </div>
            </template>
          </div>
          <div class="tabloo-elanat-table-view">
            <vue-bootstrap4-table
              v-if="$store.state.renderComponent"
              :rows="RowsDetail"
              :columns="ColumnsDetail"
              :config="config"
              :classes="classes"
            >
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <p class="text-center">{{ props.row.vbt_id }}</p>
              </template>
              <template slot="isActive" slot-scope="props">
                <span
                  class="tabloo-elanat-card__badge"
                  :class="
                    props.row.isActive
                      ? 'tabloo-elanat-card__badge--on'
                      : 'tabloo-elanat-card__badge--off'
                  "
                >
                  {{ props.row.isActive == true ? "فعال" : "غیر فعال" }}
                </span>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ModalCustom from "../Tools/ModalCustom.vue";

export default {
  components: {
    NetPaCard,
    NetPaTab,
    Panel,
    VueBootstrap4Table,
    Treeselect,
    ModalCustom,
  },
  data() {
    return {
      activeTab: "nav-elanat-list",
      cardSearch: "",
      cardPage: 1,
      cardPerPage: 10,
      detailCardSearch: "",
      detailCardPage: 1,
      detailCardPerPage: 10,
      DataAxios: {
        Id: 1,
        BnpCashDbtblTabloElanatId: 0,
        wwwtblTafsiliTypeId: [],
        WwwtblShobeId: 0,
        TxtMatnTabloElanat: "",
        AzTarixSaat: "",
        TaTarixSaat: "",
        IsActive: true,
        ZamanInsert: "",
        WwwtblAzaNoeIds: "0",
        SubjectTabloElanat: "",
        Tartib: 1,
        NamayeshInLogin: false,
        wwwtblAzaIdInsert: 0,
      },
      TafsilyList: [],
      Rows: [],
      RowsDetail: [],
      Columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },
        {
          label: "عنوان اعلان",
          name: "subjectTabloElanat",
          visibility: true,
        },
        {
          label: "متن اعلان",
          name: "txtMatnTabloElanat",
          visibility: true,
        },
        {
          label: "تاریخ شروع نمایش",
          name: "azTarixSaat",
          visibility: true,
        },
        {
          label: "تاریخ پایان نمایش",
          name: "taTarixSaat",
          visibility: true,
        },
        {
          label: "وضعیت نمایش",
          name: "isActive",
          visibility: true,
        },
        {
          label: "امکانات",
          name: "Action",
          visibility: true,
        },
      ],
      ColumnsDetail: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },
        {
          label: "شعبه",
          name: "nameTafsiliType",
          visibility: true,
        },
        {
          label: "وضعیت نمایش",
          name: "isActive",
          visibility: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      options3: [],
      multiple: true,
      clearable: false,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      value3: [],
      normalizer3(node) {
        return {
          id: node.id,
          label: node.nameTafsiliType,
        };
      },
      EditMode: false,
    };
  },
  computed: {
    ElanatTabs() {
      return [
        { id: "nav-elanat-list", title: "لیست اعلانات" },
        {
          id: "nav-elanat-form",
          title: this.EditMode ? "ویرایش اعلان" : "ثبت اعلان",
        },
      ];
    },
    filteredCardRows() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.Rows;
      return this.Rows.filter((row) => {
        const hay = [
          row.subjectTabloElanat,
          row.txtMatnTabloElanat,
          row.azTarixSaat,
          row.taTarixSaat,
          row.isActive ? "فعال" : "غیر فعال",
        ]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage;
      return this.filteredCardRows.slice(start, start + this.cardPerPage);
    },
    cardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredCardRows.length / this.cardPerPage),
      );
    },
    filteredDetailCardRows() {
      const q = (this.detailCardSearch || "").trim().toLowerCase();
      if (!q) return this.RowsDetail;
      return this.RowsDetail.filter((row) => {
        const hay = [
          row.nameTafsiliType,
          row.isActive ? "فعال" : "غیر فعال",
        ]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedDetailCardRows() {
      const start = (this.detailCardPage - 1) * this.detailCardPerPage;
      return this.filteredDetailCardRows.slice(
        start,
        start + this.detailCardPerPage,
      );
    },
    detailCardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredDetailCardRows.length / this.detailCardPerPage),
      );
    },
  },
  watch: {
    Rows() {
      this.cardPage = 1;
    },
    cardSearch() {
      this.cardPage = 1;
    },
    RowsDetail() {
      this.detailCardPage = 1;
    },
    detailCardSearch() {
      this.detailCardPage = 1;
    },
  },
  methods: {
    cardValue(val) {
      if (val == null || val === "") return "—";
      return val;
    },
    onTabChange(id) {
      this.activeTab = id;
      if (id === "nav-elanat-form" && !this.EditMode) {
        return;
      }
    },
    switchTab(id) {
      this.activeTab = id;
      this.$nextTick(() => {
        const link = document.getElementById(id + "-tab");
        if (link && window.$) {
          window.$(link).tab("show");
        } else if (link) {
          link.click();
        }
      });
    },
    GetTafsiliType() {
      var formdata = new FormData();
      formdata.append("custcode", this.$session.get("CustCode"));
      var DataAxios_TafsiliType2 = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "TafsiliType/GetAll",
        Token: "",
      };
      this.$PostFormData(DataAxios_TafsiliType2).then((data) => {
        if (this.$session.get("IsRahbar")) {
          this.options3 = data;
        }
        if (
          this.$session.get("ModirShobe") &&
          !this.$session.get("IsRahbar")
        ) {
          this.TafsilyList = data.find(
            (x) =>
              x.id == this.$session.get("UserInfoNetPa").wwwtblTafsiliTypeId,
          );
        }
      });
    },
    SetBoard() {
      if (this.$ValidForm("TablooElanat")) {
        this.DataAxios.wwwtblTafsiliTypeId = [];
        if (this.$session.get("IsRahbar")) {
          this.DataAxios.wwwtblTafsiliTypeId = this.value3;
        }
        if (
          this.$session.get("ModirShobe") &&
          !this.$session.get("IsRahbar")
        ) {
          this.DataAxios.wwwtblTafsiliTypeId.push(
            this.$session.get("UserInfoNetPa").wwwtblTafsiliTypeId,
          );
        }
        this.DataAxios.WwwtblShobeId =
          this.$session.get("UserInfoNetPa").wwwtblShobeId;
        this.DataAxios.wwwtblAzaIdInsert =
          this.$session.get("UserInfoNetPa").wwwtblAzaId;
        var DataAxios_SetTabloo = {
          ArryfildValue: this.DataAxios,
          Method: "Post",
          Action: "TablooElanat/SetTablo",
          Token: this.$session.get("TokenNetPa"),
        };
        if (this.$session.get("IsRahbar")) {
          if (this.value3.length > 0) {
            this.$PostData(DataAxios_SetTabloo).then((data) => {
              if (data.status == "OK") {
                this.$mySweetDefault(
                  "عملیات موفق",
                  "ثبت اعلان با موفقیت انجام شد",
                  "success",
                  2000,
                );
                this.GetGrid();
                this.CancelEdit();
                this.switchTab("nav-elanat-list");
                this.$store.state.renderComponentGrid = false;
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true;
                });
              }
            });
          } else {
            this.$mySweetDefault(
              "فیلد الزامی",
              "انتخاب حداقل یک شعبه برای ثبت تابلو اعلان الزامی می باشد",
              "error",
              3000,
            );
          }
        } else {
          this.$PostData(DataAxios_SetTabloo).then((data) => {
            if (data.status == "OK") {
              this.$mySweetDefault(
                "عملیات موفق",
                "ثبت اعلان با موفقیت انجام شد",
                "success",
                2000,
              );
              this.GetGrid();
              this.CancelEdit();
              this.switchTab("nav-elanat-list");
              this.$store.state.renderComponentGrid = false;
              this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true;
              });
            }
          });
        }
      }
    },
    GetGrid() {
      const formData = new FormData();
      formData.append("AzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      var DataAxios_GetTabloo = {
        ArryfildValue: formData,
        Method: "Post",
        Action: "TablooElanat/GetTabloo",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios_GetTabloo).then((data) => {
        if (data.data.length > 0) {
          this.Rows = data.data;
          for (let index = 0; index < data.data.length; index++) {
            this.DataAxios.Tartib = index + 1;
          }
        } else {
          this.Rows = [];
        }
      });
    },
    Active(row, Active) {
      const formData = new FormData();
      formData.append("Active", Active);
      formData.append("wwwtblTabloElanatId", row.id);
      var DataAxios_Active = {
        ArryfildValue: formData,
        Method: "Post",
        Action: "TablooElanat/IsActive",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios_Active).then((data) => {
        if (data.status == "Ok") {
          this.GetGrid();
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        } else {
          this.$mySweetDefault(
            "خطایی رخ داده",
            "در تغییر حالت اعلان خطایی رخ داده ، در صورت تکرار خطا با پشتیبانی تماس حاصل کنید",
            "warning",
            2000,
          );
        }
      });
    },
    ItemSelected3(node) {
      this.value3.push(node.id);
    },
    ItemDeselect3(node) {
      for (let index = 0; index < this.value3.length; index++) {
        if (this.value3[index] == node.id) {
          this.value3.splice(index, 1);
        }
      }
    },
    GetDetail(row) {
      return new Promise((success) => {
        const formData = new FormData();
        formData.append(
          "AzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblTabloElanatId", row.id);
        var DataAxios_GetTabloo = {
          ArryfildValue: formData,
          Method: "Post",
          Action: "TablooElanat/GetDetail",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostFormData(DataAxios_GetTabloo).then((data) => {
          this.RowsDetail = data.data;
          this.detailCardSearch = "";
          this.detailCardPage = 1;
          success(data.data);
        });
      });
    },
    OnEdit(row, IsRahbar) {
      this.GetDetail(row).then((data) => {
        var Detail = [];
        data.forEach((element) => {
          Detail.push(element.wwwtblTafsiliTypeId);
        });

        if (IsRahbar) {
          this.value3 = Detail;
          this.DataAxios = {
            Id: row.id,
            BnpCashDbtblTabloElanatId: row.bnpCashDbtblTabloElanatId,
            wwwtblTafsiliTypeId: this.value3,
            WwwtblShobeId: row.wwwtblShobeId,
            TxtMatnTabloElanat: row.txtMatnTabloElanat,
            AzTarixSaat: row.azTarixSaat,
            TaTarixSaat: row.taTarixSaat,
            IsActive: row.isActive,
            ZamanInsert: row.zamanInsert,
            WwwtblAzaNoeIds: row.wwwtblAzaNoeIds,
            SubjectTabloElanat: row.subjectTabloElanat,
            Tartib: row.tartib,
            NamayeshInLogin: row.namayeshInLogin,
            wwwtblAzaIdInsert: row.wwwtblAzaIdInsert,
          };
          this.EditMode = true;
        } else {
          this.DataAxios = {
            Id: row.id,
            BnpCashDbtblTabloElanatId: row.bnpCashDbtblTabloElanatId,
            wwwtblTafsiliTypeId: Detail,
            WwwtblShobeId: row.wwwtblShobeId,
            TxtMatnTabloElanat: row.txtMatnTabloElanat,
            AzTarixSaat: row.azTarixSaat,
            TaTarixSaat: row.taTarixSaat,
            IsActive: row.isActive,
            ZamanInsert: row.zamanInsert,
            WwwtblAzaNoeIds: row.wwwtblAzaNoeIds,
            SubjectTabloElanat: row.subjectTabloElanat,
            Tartib: row.tartib,
            NamayeshInLogin: row.namayeshInLogin,
            wwwtblAzaIdInsert: row.wwwtblAzaIdInsert,
          };
          this.EditMode = true;
        }
        this.switchTab("nav-elanat-form");
      });
    },
    Edit() {
      if (this.$session.get("IsRahbar")) {
        this.DataAxios.wwwtblTafsiliTypeId = this.value3;
      }
      var DataAxios_EditTabloo = {
        ArryfildValue: this.DataAxios,
        Method: "Put",
        Action: "TablooElanat/EditTabloo",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxios_EditTabloo).then((data) => {
        if (data.status == "OK") {
          this.$mySweetDefault(
            "عملیات موفق",
            "ویرایش اعلان با موفقیت انجام شد",
            "success",
            2000,
          );
        }
        this.GetGrid();
        this.CancelEdit();
        this.switchTab("nav-elanat-list");
        this.$store.state.renderComponentGrid = false;
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true;
        });
      });
    },
    CancelEdit() {
      this.EditMode = false;
      this.value3 = [];
      this.DataAxios = {
        Id: 1,
        BnpCashDbtblTabloElanatId: 0,
        wwwtblTafsiliTypeId: [],
        WwwtblShobeId: 0,
        TxtMatnTabloElanat: "",
        AzTarixSaat: "",
        TaTarixSaat: "",
        IsActive: true,
        ZamanInsert: "",
        WwwtblAzaNoeIds: "0",
        SubjectTabloElanat: "",
        Tartib: 1,
        NamayeshInLogin: false,
        wwwtblAzaIdInsert: 0,
      };
    },
    OnDelete(row) {
      this.$mySweetDefaultTost(
        "درحال حذف تابلو",
        "لطفا منتظر بمانید ...",
        "info",
        false,
      );
      const formData = new FormData();
      formData.append("TablooId", row.id);
      var DataAxios_DeleteTabloo = {
        ArryfildValue: formData,
        Method: "delete",
        Action: "TablooElanat/DeleteTabloo",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios_DeleteTabloo).then((data) => {
        if (data.status == "OK") {
          this.$mySweetDefault(
            "حذف موفق",
            "اعلان مورد نظر با موفقیت حذف شد",
            "success",
            2000,
          );
          this.GetGrid();
          this.CancelEdit();
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        }
      });
    },
  },
  mounted() {
    this.GetTafsiliType();
    this.GetGrid();
  },
};
</script>
<style>
.vue-treeselect {
  z-index: 1000 !important;
}

#TablooElanatPage .tabloo-elanat-form {
  width: 100%;
}

#TablooElanatPage .tabloo-elanat-banner {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0 0 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #eed9b0;
  border-radius: 14px;
  background: #fdf8ef;
}

#TablooElanatPage .tabloo-elanat-banner strong {
  color: #7a5410;
  font-size: 13px;
  font-weight: 800;
}

#TablooElanatPage .tabloo-elanat-banner span {
  color: #9a6b16;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
}

#TablooElanatPage .tabloo-elanat-fields {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 0.75rem;
}

#TablooElanatPage .tabloo-elanat-field {
  display: flex;
  flex-direction: column;
  grid-column: span 4;
  min-width: 0;
}

#TablooElanatPage .tabloo-elanat-field--lg {
  grid-column: span 6;
}

#TablooElanatPage .tabloo-elanat-field--sm {
  grid-column: span 2;
}

#TablooElanatPage .tabloo-elanat-field--wide {
  grid-column: 1 / -1;
}

#TablooElanatPage .tabloo-elanat-label {
  display: block;
  margin-bottom: 0.35rem;
  color: #29345f;
  font-size: 13px;
  font-weight: 700;
}

#TablooElanatPage .tabloo-elanat-field .form-control,
#TablooElanatPage .tabloo-elanat-field textarea.form-control {
  width: 100%;
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

#TablooElanatPage .tabloo-elanat-field textarea.form-control {
  min-height: 8rem;
  resize: vertical;
}

#TablooElanatPage .tabloo-elanat-field .form-control:focus,
#TablooElanatPage .tabloo-elanat-field textarea.form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

#TablooElanatPage .tabloo-elanat-field .vpd-main {
  display: block;
  width: 100%;
}

#TablooElanatPage .tabloo-elanat-field .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

#TablooElanatPage .tabloo-elanat-field .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#TablooElanatPage .tabloo-elanat-field .vpd-input-group input,
#TablooElanatPage .tabloo-elanat-field .vpd-input-group input.form-control {
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
}

#TablooElanatPage .tabloo-elanat-field .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

#TablooElanatPage .tabloo-elanat-form__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 1rem;
}

#TablooElanatPage .tabloo-elanat-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 40px;
  padding: 0.45rem 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

#TablooElanatPage .tabloo-elanat-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.16);
}

#TablooElanatPage .tabloo-elanat-btn--ghost {
  color: #29345f;
  border: 1px solid #dbe5eb;
  background: #fff;
}

#TablooElanatPage .tabloo-elanat-cards {
  display: none;
}

#TablooElanatPage .tabloo-elanat-cards__toolbar {
  display: flex;
  margin: 0 0 0.85rem;
}

#TablooElanatPage .tabloo-elanat-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

#TablooElanatPage .tabloo-elanat-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

#TablooElanatPage .tabloo-elanat-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

#TablooElanatPage .tabloo-elanat-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

#TablooElanatPage .tabloo-elanat-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

#TablooElanatPage .tabloo-elanat-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.55rem;
}

#TablooElanatPage .tabloo-elanat-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

#TablooElanatPage .tabloo-elanat-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

#TablooElanatPage .tabloo-elanat-card__badge--on {
  color: #2f7a1f;
  background: #eef8ec;
}

#TablooElanatPage .tabloo-elanat-card__badge--off {
  color: #b44f46;
  background: #fcefed;
}

#TablooElanatPage .tabloo-elanat-card__text {
  margin: 0 0 0.75rem;
  color: #29345f;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.7;
  overflow-wrap: anywhere;
  word-break: break-word;
}

#TablooElanatPage .tabloo-elanat-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

#TablooElanatPage .tabloo-elanat-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

#TablooElanatPage .tabloo-elanat-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

#TablooElanatPage .tabloo-elanat-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
}

#TablooElanatPage .tabloo-elanat-card__actions,
#TablooElanatPage .tabloo-elanat-table-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.75rem;
}

#TablooElanatPage .tabloo-elanat-table-actions {
  margin-top: 0;
}

#TablooElanatPage .tabloo-elanat-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 34px;
  padding: 0.3rem 0.7rem;
  border: 1px solid;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

#TablooElanatPage .tabloo-elanat-chip--detail {
  color: #287db4;
  border-color: #cfe4f2;
  background: #edf5fb;
}

#TablooElanatPage .tabloo-elanat-chip--edit {
  color: #9a6b16;
  border-color: #eed9b0;
  background: #fdf8ef;
}

#TablooElanatPage .tabloo-elanat-chip--delete {
  color: #b44f46;
  border-color: #f0c9c5;
  background: #fcefed;
}

#TablooElanatPage .tabloo-elanat-chip--off {
  color: #b44f46;
  border-color: #f0c9c5;
  background: #fff;
}

#TablooElanatPage .tabloo-elanat-chip--on {
  color: #2f7a1f;
  border-color: #b7dfb0;
  background: #eef8ec;
}

#TablooElanatPage .tabloo-elanat-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

#TablooElanatPage .tabloo-elanat-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

#TablooElanatPage .tabloo-elanat-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

#TablooElanatPage .tabloo-elanat-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

#TablooElanatPage .tabloo-elanat-detail__title {
  margin: 0 0 0.85rem;
  color: #29345f;
  font-size: 15px;
  font-weight: 800;
}

@media (max-width: 767px) {
  #TablooElanatPage .tabloo-elanat-cards,
  #TablooElanatPage .tabloo-elanat-detail-cards {
    display: block;
  }

  #TablooElanatPage .tabloo-elanat-table-view {
    display: none;
  }

  #TablooElanatPage .tabloo-elanat-field,
  #TablooElanatPage .tabloo-elanat-field--lg,
  #TablooElanatPage .tabloo-elanat-field--sm,
  #TablooElanatPage .tabloo-elanat-field--wide {
    grid-column: 1 / -1;
  }

  #TablooElanatPage .tabloo-elanat-btn {
    width: 100%;
  }

  #TablooElanatPage .tabloo-elanat-card__actions .tabloo-elanat-chip {
    flex: 1 1 7rem;
  }
}
</style>
